import { Component, OnInit, Input } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { CompanyService } from '../../../../services';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import {
  SelectApplicationModal,
  DepartmentUserModal,
  UnitAddModal,
  DepartmentNewModal,
  DepartmentUnitModal,
} from 'src/modules/features/admin/modals';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-contractor-company-record',
  templateUrl: './company-record.component.html',
  styleUrls: ['./company-record.component.scss'],
})
export class RecordComponent implements OnInit {
  companyRecords = [];
  @Input() units;
  companyTcc: any = [];
  success: any;
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId: string;
  pendingDocuments;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'year',
        op: 'cn',
        data: '',
      },
      {
        field: 'assessableProfit',
        op: 'cn',
        data: '',
      },
      {
        field: 'turnOver',
        op: 'cn',
        data: '',
      },
    ],
  };

  // organizationTypeId = JSON.parse(window.localStorage.getItem('userData'))['appUser']['organization'][
  // 	'organizationTypeId'
  // ]['organizationTypeId'];

  constructor(
    private modalService: SuiModalService,
    private companySvc: CompanyService
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10 });
    // this.getPage(1);
    // this.activatedRoute.parent.params.subscribe((params) => {
    // 	this.projectId = params['id'];
    // });
  }

  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.companySvc
      .getCompanyTcc({
        organizationId: this.organizationId,
        params: this.filter,
      })
      .subscribe((res: any) => {
        this.pending = false;
        this.companyTcc = res['rows'];
        this.getCompanyTcc();
      });
  }

  getCompanyTcc() {
    this.pending = true;
    this.companySvc
      .getCompanyTccRecord({
        organizationId: this.organizationId,
        tccId: this.companyTcc[0].organizationTccId,
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.companyRecords = res['rows'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  newUser() {
    this.modalService
      .open(
        new DepartmentUserModal('Assign User to Department', '', ModalSize.Tiny)
      )
      .onApprove((payload) => {})
      .onDeny(() => {});
  }
  assignApp() {
    this.modalService
      .open(
        new SelectApplicationModal(
          'Assign Application to Department',
          '',
          ModalSize.Tiny
        )
      )
      .onApprove((payload) => {})
      .onDeny(() => {});
  }
  onChange(event, equipment) {}
  getApplication() {}
  ngOnInit(): void {
    // this.viewCert();
    // console.log(
    // 	JSON.parse(localStorage.getItem('userData'))['appUser']['organization']['organizationTypeId'][
    // 		'organizationTypeId'
    // 	]
    // );
  }
}
